import React from "react";
import { Tooltip } from "antd";
import { InfoIcon } from "../../../icons-and-animations/icons";
import { toTitleCase } from "./helpers";

interface ItemTitleProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  className?: string;
}

export const ItemTitle: React.FC<ItemTitleProps> = ({
  icon,
  title,
  description,
  className = "",
}) => {
  return (
    <div className={`item-title ${className}`}>
      {icon}
      <div className="item-title-content">
        <Tooltip title={toTitleCase(title)}>
          <span>{toTitleCase(title)}</span>
        </Tooltip>
        {description && (
          <Tooltip title={description}>
            <div className="info-icon-wrapper">
              <InfoIcon />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
